import React, {FC} from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import {PageTitle} from '../../../_metronic/layout/core'

const BerandaPage: FC = () => {
  const [satuanKerjaCode, satuanKerjaName] = useSelector<RootState>(({auth}) => {
    return [
      auth.user?.pegawaiData.administrative_unit_id,
      auth.user?.pegawaiData.administrative_name,
    ]
  }) as string[]
  return (
    <>
      <div className='row'>
        <div className='col-12'>
          <div className='card bg-danger mb-4'>
            <div className='card-header align-items-center border-0'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='fw-bolder mb-2 text-light fs-2'>{satuanKerjaName}</span>
                <span className='text-light fw-bold fs-6'>{satuanKerjaCode}</span>
              </h3>
            </div>
          </div>
          <div className='card mb-4'>
            <div className='card-header align-items-center border-0'>
              <h3 className='card-title align-items-start'>
                <span className='fw-bolder mb-2 text-dark'>
                  Kinerja Satuan Kerja Berdasarkan Akuntabilitas Kepatuhan Pelaporan{' '}
                  <span className='text-danger'>Komponen</span>
                </span>
              </h3>
            </div>
            <div className='card-body align-items-center pt-0'>
              <table className='table gy-4'>
                <thead>
                  <tr className='fw-bold fs-3 text-gray-800 text-center'>
                    <th className='bg-light-success text-success'>JAN</th>
                    <th className='bg-light-danger text-danger'>FEB</th>
                    <th className='bg-light-success text-success'>MAR</th>
                    <th className='bg-light-warning text-warning'>APR</th>
                    <th className='bg-light-warning text-warning'>MEI</th>
                    <th className='bg-light-warning text-warning'>JUN</th>
                    <th className='bg-light-success text-success'>JUL</th>
                    <th className='bg-light-success text-success'>AGU</th>
                    <th className='bg-light-success text-success'>SEP</th>
                    <th className='bg-light-success text-success'>OKT</th>
                    <th className='bg-light-danger text-danger'>NOV</th>
                    <th className='bg-light-success text-success'>DES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='text-center'>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-danger text-danger'>
                      <i className='fa fa-exclamation-triangle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-warning text-warning'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-warning text-warning'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-warning text-warning'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-danger text-danger'>
                      <i className='fa fa-exclamation-triangle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                  </tr>
                  <tr className='text-center fs-3'>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-danger text-danger'>0%</td>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-warning text-warning'>94%</td>
                    <td className='bg-light-warning text-warning'>97%</td>
                    <td className='bg-light-warning text-warning'>96%</td>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-danger text-danger'>0%</td>
                    <td className='bg-light-success text-success'>100%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className='card'>
            <div className='card-header align-items-center border-0'>
              <h3 className='card-title align-items-start'>
                <span className='fw-bolder mb-2 text-dark'>
                  Kinerja Satuan Kerja Berdasarkan Akuntabilitas Kepatuhan Pelaporan{' '}
                  <span className='text-danger'>Rincian Output</span>
                </span>
              </h3>
            </div>
            <div className='card-body align-items-center pt-0'>
              <table className='table gy-4'>
                <thead>
                  <tr className='fw-bold fs-3 text-gray-800 text-center'>
                    <th className='bg-light-success text-success'>JAN</th>
                    <th className='bg-light-danger text-danger'>FEB</th>
                    <th className='bg-light-success text-success'>MAR</th>
                    <th className='bg-light-warning text-warning'>APR</th>
                    <th className='bg-light-warning text-warning'>MEI</th>
                    <th className='bg-light-warning text-warning'>JUN</th>
                    <th className='bg-light-success text-success'>JUL</th>
                    <th className='bg-light-success text-success'>AGU</th>
                    <th className='bg-light-success text-success'>SEP</th>
                    <th className='bg-light-success text-success'>OKT</th>
                    <th className='bg-light-danger text-danger'>NOV</th>
                    <th className='bg-light-success text-success'>DES</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className='text-center'>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-danger text-danger'>
                      <i className='fa fa-exclamation-triangle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-warning text-warning'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-warning text-warning'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-warning text-warning'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                    <td className='bg-light-danger text-danger'>
                      <i className='fa fa-exclamation-triangle fs-3x'></i>
                    </td>
                    <td className='bg-light-success text-success'>
                      <i className='fa fa-check-circle fs-3x'></i>
                    </td>
                  </tr>
                  <tr className='text-center fs-3'>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-danger text-danger'>0%</td>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-warning text-warning'>94%</td>
                    <td className='bg-light-warning text-warning'>97%</td>
                    <td className='bg-light-warning text-warning'>96%</td>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-success text-success'>100%</td>
                    <td className='bg-light-danger text-danger'>0%</td>
                    <td className='bg-light-success text-success'>100%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const BerandaWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Beranda</PageTitle>
      <BerandaPage></BerandaPage>
    </>
  )
}

export {BerandaWrapper}
